export default "__VITE_ASSET__b6ba5869__"